/* eslint-disable no-irregular-whitespace */
import { AxiosResponse } from 'axios'
import cpf from 'Hooks/useMask/cpf'
import { UsuarioAtual, Roles } from 'Models/auth'
import ApiService from 'Services/ApiService'
import handleToken from 'Services/handleToken'
import { UserJwtAuthenticateResponse } from 'Services/UAA/types/response'
import { UserJwtAuthenticateRequest } from 'Services/UAA/types/resquest'

import hosts from '../../config/microServices'

const AuthService = {
  Login: async (authRequest: UserJwtAuthenticateRequest): Promise<boolean> => {
    authRequest.username = cpf.clean(authRequest.username).toString()

    const result = await ApiService({
      anonymous: true,
    }).post<UserJwtAuthenticateResponse>(
      `${hosts.UAA_URL}/authenticate`,
      authRequest,
    )

    if (result?.data && result?.data?.id_token) {
      handleToken.setToken(result?.data?.id_token)
      return true
    } else {
      return false
    }
  },

  Me: async () => {
    const result: AxiosResponse<UsuarioAtual> =
      await ApiService().get<UsuarioAtual>(
        `${hosts.WS_DOCAS}/autenticacao_info`,
      )

    return result
  },

  RecoverPasswordInit: async (
    cpf?: string,
    email?: string,
  ): Promise<boolean> => {
    const { data } = await ApiService({
      anonymous: true,
    }).post<any>(`${hosts.UAA_URL}​/account​/reset-password​/init`, {
      cpf: cpf,
      email: email,
    })

    return data ? true : false
  },

  GetRoles: async () => {
    return await ApiService().get<Roles[]>(`${hosts.UAA_URL}/role`)
  },
}

export default AuthService
